import { Box, Container } from '@chakra-ui/react';

import { EventType } from '@lib/types';

import Hero from '../../components/events/Hero';
import { ContainerMaxW } from '../../layouts/EventLayout';

type Props = {
  event: EventType;
};

const HeroSection = ({ event }: Props) => {
  return (
    <Box w="full" bg="#f7f7f7" py={{ base: '45px', md: '90px' }}>
      <Container maxW={ContainerMaxW}>
        <Hero event={event} />
      </Container>
    </Box>
  );
};

export default HeroSection;
